<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8 10C8.82843 10 9.5 9.32843 9.5 8.5C9.5 7.67157 8.82843 7 8 7C7.17157 7 6.5 7.67157 6.5 8.5C6.5 9.32843 7.17157 10 8 10ZM17.5 8.5C17.5 9.32843 16.8284 10 16 10C15.1716 10 14.5 9.32843 14.5 8.5C14.5 7.67157 15.1716 7 16 7C16.8284 7 17.5 7.67157 17.5 8.5ZM15.6526 16.7601C14.6047 17.5642 13.3208 18 12 18C10.6792 18 9.3953 17.5642 8.34743 16.7601C7.29957 15.9561 6.54629 14.8287 6.20445 13.5529C6.0615 13.0194 5.51317 12.7029 4.9797 12.8458C4.44623 12.9887 4.12965 13.5371 4.27259 14.0706C4.72839 15.7716 5.73275 17.2748 7.12991 18.3468C8.52706 19.4189 10.2389 20 12 20C13.7611 20 15.4729 19.4189 16.8701 18.3468C18.2672 17.2748 19.2716 15.7716 19.7274 14.0706C19.8703 13.5371 19.5538 12.9888 19.0203 12.8458C18.4868 12.7029 17.9385 13.0194 17.7956 13.5529C17.4537 14.8287 16.7004 15.9561 15.6526 16.7601Z"
      fill="#04D443"
    />
  </svg>
</template>

<script>
export default {
  name: "PositiveIcon"
};
</script>
